import logo from "assets/img/scale_lens_logo.png";

const legalLinks = [
  { label: "Privacy Policy", href: "https://scalelens.app/privacy-policy" },
  { label: "Terms of Service", href: "https://scalelens.app/terms-of-service" },
  { label: "Refund Policy", href: "https://scalelens.app/refund-policy" },
  { label: "DPA", href: "https://scalelens.app/data-processing-agreement" },
  { label: "SLA", href: "https://scalelens.app/support-and-service-level-agreement" },
  { label: "Contact", href: "mailto:info@scalelens.app" },
];

const Footer = () => {
  return (
    <footer className="border-t border-[#E4E7EB] bg-white py-8 px-6 mt-auto">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-[14px] text-[#6B7280]">
        <img src={logo} alt="ScaleLens" className="h-6 w-auto" />

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
          {legalLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target={link.href.startsWith("mailto") ? undefined : "_blank"}
              rel="noopener noreferrer"
              className="hover:text-[#1F2937] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        <span className="whitespace-nowrap">© {new Date().getFullYear()} ScaleLens. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
